import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Capture the PWA install prompt early (fires before lazy pages load)
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); window.__installPrompt = e; });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register PWA service worker in PRODUCTION only (hashed bundles make cache-first safe).
// In dev/preview the bundle is unhashed — a SW would serve stale code, so unregister any.
if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      // Check for updates immediately and on every navigation
      reg.update().catch(() => {});

      // If a new SW takes control mid-session, reload once so the user
      // gets the latest bundle without hitting a "stuck" state.
      let reloaded = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (reloaded) return;
        reloaded = true;
        window.location.reload();
      });

      // Listen for new SW installation
      reg.addEventListener('updatefound', () => {
        const newSW = reg.installing;
        if (!newSW) return;
        newSW.addEventListener('statechange', () => {
          // New SW is installed and waiting — activate it now
          if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
            newSW.postMessage({ type: 'SKIP_WAITING' });
          }
        });
      });
    }).catch(() => {});
  });
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      const had = regs.length > 0;
      regs.forEach((r) => r.unregister());
      if ('caches' in window) caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      if (had) setTimeout(() => window.location.reload(), 300);
    }).catch(() => {});
  }
}
